import { Pipe, PipeTransform } from '@angular/core';
import { UtilService } from 'src/app/core';

@Pipe({ name: 'diffTimeFromNow' })
export class DiffTimeFromNow implements PipeTransform {
  transform(date: string) {
    return UtilService.getDiffTimeFromNowUI(date);
  }
}
